import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { MechanicShiftDetails } from '../../business-entities/mechanic-shift-details.model';
import { MechanicSlotDetailsViewModel } from './../../business-entities/mechanic-slot-details.model';

@Pipe({
  name: 'MechanicSlotFilterPipe'
})
export class MechanicSlotFilterPipe implements PipeTransform {

  constructor(
    public datepipe: DatePipe
  ) { }

  transform(mechanicDetailViewModel: MechanicShiftDetails[], mechanicIndex: number, _hourIndex: number, _dayIndex: number, mechanicDate: Date, hour): any {
    mechanicDate = new Date(mechanicDate.setHours(0,0,0));
    const mechanicDetails = mechanicDetailViewModel[mechanicIndex];
    const startdDateTime = this.GetDateWithHour(hour, mechanicDate);
    let mechamicSlotDetails: MechanicSlotDetailsViewModel[] = [];
    if(mechanicDetails.shiftStartTime != null && mechanicDetails.shiftEndTime != null){

    let shiftStartData =  this.datepipe.transform(mechanicDetails.shiftStartTime, 'HH:mm');
    let shiftEndData = this.datepipe.transform(mechanicDetails.shiftEndTime, 'HH:mm');
    let startTime = this.GetDateWithHour(+shiftStartData.split(":")[0],mechanicDate);
    let endTime = this.GetDateWithHour(+shiftEndData.split(":")[0],mechanicDate);
    const mechanicShiftStart = this.addMinutes(startTime,+shiftStartData.split(":")[1]);
    const mechanicShiftEnd = this.addMinutes(endTime,+shiftEndData.split(":")[1]);
    let mechanicLunchTimeStartTime = null;
    let mechanicLunchTimeEndTime = null;
    let mechanicBreak1TimeStartTime = null;
    let mechanicBreak1TimeEndTime = null;
    let mechanicBreak2TimeStartTime = null;
    let mechanicBreak2TimeEndTime = null;
    let CsplitDate = this.datepipe.transform(mechanicDate,'yyyy-MM-ddTHH:MM:SS').split('T')[0];

    if(mechanicDetails.lunchStartTime == undefined || mechanicDetails.lunchEndTime == undefined || mechanicDetails.lunchStartTime == null || mechanicDetails.lunchEndTime == null){
      mechanicLunchTimeStartTime = null;
      mechanicLunchTimeEndTime = null;
    }
    else{
      let lStartTime = mechanicDetails.lunchStartTime?.toString().split('T')[1];
      let lEndTime = mechanicDetails.lunchEndTime?.toString().split('T')[1];
      let mechaniclunchStartTime = CsplitDate +'T'+lStartTime;
      let mechaniclunchEndTime = CsplitDate +'T'+lEndTime;
      let lunchStartData = this.datepipe.transform(mechaniclunchStartTime, 'HH:mm');
      let lunchEndData = this.datepipe.transform(mechaniclunchEndTime, 'HH:mm');
      // let lunchStartData = Utility.ConvertUTCDateToLocalTime(mechaniclunchStartTime);
      // let lunchEndData = Utility.ConvertUTCDateToLocalTime(mechaniclunchEndTime);
  
      
      let lunchstartTime = this.GetDateWithHour(+lunchStartData.split(":")[0],mechanicDate);
      let lunchendTime = this.GetDateWithHour(+lunchEndData.split(":")[0],mechanicDate);
      mechanicLunchTimeStartTime = this.addMinutes(lunchstartTime,+lunchStartData.split(":")[1]);
      mechanicLunchTimeEndTime = this.addMinutes(lunchendTime,+lunchEndData.split(":")[1]);
    }

    if(mechanicDetails.break1StartTime == undefined || mechanicDetails.break1EndTime == undefined || mechanicDetails.break1StartTime == null || mechanicDetails.break1EndTime == null){
      mechanicBreak1TimeStartTime = null;
      mechanicBreak1TimeEndTime = null;
    }
    else{
      let lStartTime = mechanicDetails.break1StartTime?.toString().split('T')[1];
      let lEndTime = mechanicDetails.break1EndTime?.toString().split('T')[1];
      let mechanicBreak1StartTime = CsplitDate +'T'+lStartTime;
      let mechanicBreak1EndTime = CsplitDate +'T'+lEndTime;
      let break1StartData = this.datepipe.transform(mechanicBreak1StartTime, 'HH:mm');
      let break1EndData = this.datepipe.transform(mechanicBreak1EndTime, 'HH:mm');
      // let break1tartData = Utility.ConvertUTCDateToLocalTime(mechanicBreak1StartTime);
      // let break1EndData = Utility.ConvertUTCDateToLocalTime(mechanicBreak1EndTime);
        
      let break1StartTime = this.GetDateWithHour(+break1StartData.split(":")[0],mechanicDate);
      let break1EndTime = this.GetDateWithHour(+break1EndData.split(":")[0],mechanicDate);
      mechanicBreak1TimeStartTime = this.addMinutes(break1StartTime,+break1StartData.split(":")[1]);
      mechanicBreak1TimeEndTime = this.addMinutes(break1EndTime,+break1EndData.split(":")[1]);
    }

    if(mechanicDetails.break2StartTime == undefined || mechanicDetails.break2EndTime == undefined || mechanicDetails.break2StartTime == null || mechanicDetails.break2EndTime == null){
      mechanicBreak2TimeStartTime = null;
      mechanicBreak2TimeEndTime = null;
    }
    else{
      let lStartTime = mechanicDetails.break2StartTime?.toString().split('T')[1];
      let lEndTime = mechanicDetails.break2EndTime?.toString().split('T')[1];
      let mechanicBreak2StartTime = CsplitDate +'T'+lStartTime;
      let mechanicBreak2EndTime = CsplitDate +'T'+lEndTime;
      let break2StartData = this.datepipe.transform(mechanicBreak2StartTime, 'HH:mm');
      let break2EndData = this.datepipe.transform(mechanicBreak2EndTime, 'HH:mm');
      // let break2tartData = Utility.ConvertUTCDateToLocalTime(mechanicBreak2StartTime);
      // let break2EndData = Utility.ConvertUTCDateToLocalTime(mechanicBreak2EndTime);
        
      let break2StartTime = this.GetDateWithHour(+break2StartData.split(":")[0],mechanicDate);
      let break2EndTime = this.GetDateWithHour(+break2EndData.split(":")[0],mechanicDate);
      mechanicBreak2TimeStartTime = this.addMinutes(break2StartTime,+break2StartData.split(":")[1]);
      mechanicBreak2TimeEndTime = this.addMinutes(break2EndTime,+break2EndData.split(":")[1]);
    }
 


    let isNotAvailableForSlot=mechanicDetails.isNotAvailable;
    let leaveRemark=mechanicDetails.leaveRemark;
    let leaveOption=mechanicDetails.leaveOption;
    let notAvailableStartDateTimeForClickedDate=null;
    let notAvailableEndDateTimeForClickedDate=null;
    if(isNotAvailableForSlot)
    { 

      if(mechanicDate && mechanicDetails.notAvailableStartDateTime && mechanicDate.getDate() === Utility.ConvertUTCDateToLocalDate(mechanicDetails.notAvailableStartDateTime).getDate())
      {
        notAvailableStartDateTimeForClickedDate=Utility.ConvertUTCDateToLocalDate(mechanicDetails.notAvailableStartDateTime);
        if(mechanicDetails.notAvailableEndDateTime)
        {
          if(Utility.ConvertUTCDateToLocalDate(mechanicDetails.notAvailableEndDateTime)>mechanicShiftEnd)
            notAvailableEndDateTimeForClickedDate=mechanicShiftEnd;
          else
            notAvailableEndDateTimeForClickedDate=Utility.ConvertUTCDateToLocalDate(mechanicDetails.notAvailableEndDateTime);
        }
        // if don't have not available shift end datetime
        else
        {
          notAvailableEndDateTimeForClickedDate=mechanicShiftEnd;
        }

      }

      if(mechanicDate && mechanicDetails.notAvailableStartDateTime && mechanicDate > Utility.ConvertUTCDateToLocalDate(mechanicDetails.notAvailableStartDateTime))
      {
        notAvailableStartDateTimeForClickedDate=mechanicShiftStart;
        if(mechanicDetails.notAvailableEndDateTime)
        {
          if(Utility.ConvertUTCDateToLocalDate(mechanicDetails.notAvailableEndDateTime)>mechanicShiftEnd)
            notAvailableEndDateTimeForClickedDate=mechanicShiftEnd;
          else
            notAvailableEndDateTimeForClickedDate=Utility.ConvertUTCDateToLocalDate(mechanicDetails.notAvailableEndDateTime);
        }
        else
        {
          notAvailableEndDateTimeForClickedDate=mechanicShiftEnd;
        }
      }

      if(mechanicDate && mechanicDetails.notAvailableStartDateTime && mechanicDate < Utility.ConvertUTCDateToLocalDate(mechanicDetails.notAvailableStartDateTime))
      {
           isNotAvailableForSlot=false;
      }
    }


    let isOnLeave=mechanicDetails.isOnLeave;
    let onLeaveStartDateTimeForClickedDate=null;
    let onLeaveEndDateTimeForClickedDate=null;
    
    if(isOnLeave)
    { 

      if(mechanicDate && mechanicDetails.leaveStartDateTime && mechanicDetails.leaveEndDateTime && mechanicDate.getDate() === Utility.ConvertUTCDateToLocalDate(mechanicDetails.leaveStartDateTime).getDate())
      {
        onLeaveStartDateTimeForClickedDate=Utility.ConvertUTCDateToLocalDate(mechanicDetails.leaveStartDateTime);
          if(Utility.ConvertUTCDateToLocalDate(mechanicDetails.leaveEndDateTime)>mechanicShiftEnd)
            onLeaveEndDateTimeForClickedDate=mechanicShiftEnd;
          else
            onLeaveEndDateTimeForClickedDate=Utility.ConvertUTCDateToLocalDate(mechanicDetails.leaveEndDateTime);
      }

      if(mechanicDate && mechanicDetails.leaveStartDateTime && mechanicDetails.leaveEndDateTime && mechanicDate > Utility.ConvertUTCDateToLocalDate(mechanicDetails.leaveStartDateTime))
      {
        onLeaveStartDateTimeForClickedDate=mechanicShiftStart;
          if(Utility.ConvertUTCDateToLocalDate(mechanicDetails.leaveEndDateTime)>mechanicShiftEnd)
            onLeaveEndDateTimeForClickedDate=mechanicShiftEnd;
          else
            onLeaveEndDateTimeForClickedDate=Utility.ConvertUTCDateToLocalDate(mechanicDetails.leaveEndDateTime);
      }

      if(mechanicDate && mechanicDetails.leaveStartDateTime && mechanicDate < Utility.ConvertUTCDateToLocalDate(mechanicDetails.leaveStartDateTime))
      {
        isOnLeave = false;
      }
    }



    
    for (let i = 0; i < 60; i += 15) {
      const slotStartDateTime = this.addMinutes(startdDateTime, i);
      const slotEndDateTime = this.addMinutes(slotStartDateTime, 15);
      let mechanicSlotDetail: MechanicSlotDetailsViewModel;
      if(notAvailableStartDateTimeForClickedDate && notAvailableEndDateTimeForClickedDate && slotEndDateTime <=notAvailableEndDateTimeForClickedDate && slotEndDateTime> notAvailableStartDateTimeForClickedDate)
      {
        isNotAvailableForSlot=true;
      }
      else
      {
        isNotAvailableForSlot=false;
      }

      if(onLeaveStartDateTimeForClickedDate && onLeaveEndDateTimeForClickedDate && slotEndDateTime <=onLeaveEndDateTimeForClickedDate && slotEndDateTime> onLeaveStartDateTimeForClickedDate)
      {
        isOnLeave=true;
      }
      else
      {
        isOnLeave=false;
      }

      if (mechanicDetails.isActive) {
        let slotAppointmentList = mechanicDetailViewModel[mechanicIndex].bookedAppointmentList
          .map(x => {
            x.appointmentStartTime = new Date(x.appointmentStartTime);
            x.appointmentEndTime = new Date(x.appointmentEndTime);
            return x;
          })
          .filter(x => {
            const appointmentStartTime = new Date(x.appointmentStartTime);
            const appointmentEndTime = new Date(x.appointmentEndTime);
            if (slotStartDateTime)
              if (appointmentStartTime.getTime() < slotStartDateTime.getTime() && appointmentEndTime.getTime() <= slotStartDateTime.getTime()) {
                return false;
              } else if (appointmentStartTime.getTime() <= slotStartDateTime.getTime()) {
                return true;
              } else if (appointmentStartTime.getTime() >= slotStartDateTime.getTime() && appointmentStartTime.getTime() < slotEndDateTime.getTime()) {
                return true;
              }
          });
        const isSlotInMechanicShift = slotStartDateTime.getTime() >= mechanicShiftStart.getTime() && slotEndDateTime.getTime() <= mechanicShiftEnd.getTime();
        const isWorkStartedInSlot = slotAppointmentList.length !== 0 ? slotAppointmentList[0].appointmentStartTime.getTime() >= slotStartDateTime.getTime() : null;
        const duration = isWorkStartedInSlot ? (slotAppointmentList[0].appointmentEndTime.getTime() - slotAppointmentList[0].appointmentStartTime.getTime()) / (1000 * 60) : null;
        const isOnLunch =(slotStartDateTime.getTime() >= mechanicLunchTimeStartTime?.getTime() && slotEndDateTime.getTime() <= mechanicLunchTimeEndTime?.getTime()); 
        const isOnBreak1 =(slotStartDateTime.getTime() >= mechanicBreak1TimeStartTime?.getTime() && slotEndDateTime.getTime() <= mechanicBreak1TimeEndTime?.getTime());
        const isOnBreak2 =(slotStartDateTime.getTime() >= mechanicBreak2TimeStartTime?.getTime() && slotEndDateTime.getTime() <= mechanicBreak2TimeEndTime?.getTime());
        
        

        mechanicSlotDetail = {
          date: mechanicDate,
          slotStartTime: slotStartDateTime,
          slotEndTime: slotEndDateTime,
          isSlotInMechanicShift: isSlotInMechanicShift,
          isAvailable: slotAppointmentList.length === 0,
          isWorkStartedInSlot: isWorkStartedInSlot,
          duration: duration,
          mechanicId: mechanicDetailViewModel[mechanicIndex].mechanicId,
          mechanicName: mechanicDetailViewModel[mechanicIndex].mechanicName,
          isLeave: isOnLeave,
          leaveOption: leaveOption,
          Remark:leaveRemark,
          isNotAvailable: isNotAvailableForSlot,
          isOnLunch: isOnLunch,
          isOnBreak1:isOnBreak1,
          isOnBreak2:isOnBreak2,
          licensePlate: slotAppointmentList.length !== 0 ? slotAppointmentList[0].licensePlate : null,
          customerName: slotAppointmentList.length !== 0 ? slotAppointmentList[0].customerName : null,
          appointmentId: slotAppointmentList.length !== 0 ? slotAppointmentList[0].appointmentId : null,
          previousDate:  mechanicDate.setHours(0,0,0,0) < new Date().setHours(0,0,0,0) ? true : false,
          appointmentColor: slotAppointmentList.length !== 0 ? slotAppointmentList[0].workOrderStatusColor : null,
          brand: slotAppointmentList.length !== 0 ? slotAppointmentList[0].brand : null,
          brandCode: slotAppointmentList.length !== 0 ? slotAppointmentList[0].brandCode : null,
          boxNumber: i,
          isReserved: slotAppointmentList.length !== 0  ? slotAppointmentList[0]?.isReserved : false ,
          isunplanned: slotAppointmentList.length !== 0  ? slotAppointmentList[0]?.isunplanned : false,
          workOrderStatus:slotAppointmentList.length !== 0  ? slotAppointmentList[0]?.workOrderStatus : null,
          bookingId:  slotAppointmentList.length !== 0  ? slotAppointmentList[0]?.bookingId : null,
          isCustomerWaiting:slotAppointmentList.length !== 0 ? slotAppointmentList[0]?.isCustomerWaiting:false,
          isUnderWarranty:slotAppointmentList.length !== 0 ? slotAppointmentList[0]?.isUnderWarranty:false,
          mechanicEfficiency:mechanicDetailViewModel[mechanicIndex].mechanicEfficiency,
          serviceTime: slotAppointmentList.length !== 0 ? slotAppointmentList[0].serviceTime : null,
          isBlocked: slotAppointmentList.length !== 0  ? slotAppointmentList[0]?.isBlocked : false
        }
      } else {
        mechanicSlotDetail = {
          date: mechanicDate,
          slotStartTime: slotStartDateTime,
          slotEndTime: slotEndDateTime,
          isSlotInMechanicShift: null,
          isAvailable: false,
          isWorkStartedInSlot: null,
          duration: null,
          mechanicId: mechanicDetailViewModel[mechanicIndex].mechanicId,
          mechanicName: mechanicDetailViewModel[mechanicIndex].mechanicName,
          isLeave: isOnLeave,
          leaveOption: leaveOption,
          Remark:leaveRemark,
          isNotAvailable: isNotAvailableForSlot,
          isOnLunch: null,
          isOnBreak1:null,
          isOnBreak2:null,
          licensePlate: null,
          customerName: null,
          appointmentId: null,
          previousDate:  mechanicDate.setHours(0,0,0,0) < new Date().setHours(0,0,0,0) ? true : false,
          brand:  null,
          brandCode:  null,
          boxNumber: i,
          isReserved: false,
          isunplanned:false,
          workOrderStatus:null,
          bookingId: null,
          isCustomerWaiting:false,
          isUnderWarranty:false,
          mechanicEfficiency:mechanicDetailViewModel[mechanicIndex].mechanicEfficiency,
          serviceTime: 0,
          isBlocked: false
        }
      }
      mechamicSlotDetails.push(mechanicSlotDetail);
      
    }
    return mechamicSlotDetails;
  }
  return mechamicSlotDetails;
  }

  GetDateWithHour(hour, dateDetails: Date) {
    let dt = new Date(dateDetails.toString());
    dt.setHours(dt.getHours() + hour);
    return dt;
  }

  addMinutes(date: Date, minutes: number): Date {
    return new Date(date.getTime() + (minutes * 60 * 1000));
  }

  stringToDate(date: Date, dateString: string): Date {
    const array = dateString.split(':');
    const hour = +array[0];
    const minute = +array[1];
    let newDate = new Date(date);
    newDate.setHours(hour, minute);
    return newDate;
  }
}
